var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropdownMenu",class:[
    'dropdown-menu m-0',
    {
      'dropdown-menu--medium': _vm.width === 'md',
      'dropdown-menu--large': _vm.width === 'lg',
      'dropdown-menu--max-content': _vm.width === 'max-content',
      'w-100': _vm.width === 'inherit',
      'dropdown-menu--fixed-height': _vm.heightLimit === 'fixed'
    }
  ],on:{"&scroll":function($event){return _vm.checkScroll($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }